<template>
  <div class="mailchimp__container" :class="color">
    <transition group name="fade" mode="out-in">
      <div v-if="!sent">
        <slot name="cf7"></slot>
      </div>
      <div v-else class="mailchimp__success">
        {{ thanks }}
      </div>
  </transition>
  </div>
</template>

<script>
export default {
  name: 'MailChimp7',
  props: {
    thanks: {
      type: String,
    },
    color: {
      type: String,
    },
    form: {
      type: Number,
    },
  },
  data() {
    return {
      sent: false,
    }
  },
  mounted() {
    let vm = this
    var form = document.querySelector('.form--shop')
    document.addEventListener(
      'wpcf7mailsent',
      function (event) {
        // console.log(event.detail)
        if(event.detail.contactFormId === vm.form) {
          setTimeout(function () {
            vm.sent = true
            wpcf7.init(form)
            wpcf7.validate(form)
            wpcf7.reset(form)
          }, 200)
        }
      },
      false
    )
  },
}
</script>

<style lang="scss" scoped></style>
